<template>
  <section>
    <div class="title-h1-box">
      <h1>{{msg}}</h1>
    </div>
  </section>
</template>
<script>
  export default {
  props:{
      msg:String,
  },
  data() {
    return {
     
    };
  },
  watch: {},
  created() {
   
  },
  mounted() {},
  methods: {
    
  },
};

</script>
<style>
  @import "../../assets/css/com-title.css";
</style>
<style lang="less" scoped>
@media (max-width: 575px) {
  .title-h1-box h1{
      font-size: 26px;
    }
    .title-h1-box{
      background-repeat: no-repeat,no-repeat;
      background-position: left 10px top 17px,left 125px top 17px;
      background-size: 120px 13px,75px 13px;
    }
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {  
  .title-h1-box h1{
      font-size: 30px;
    }
    .title-h1-box{
      background-repeat: no-repeat,no-repeat;
      background-position: left 15px top 20px,left 160px top 20px;
      background-size: 150px 15px,90px 15px;
    }
  
}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991px) {
  .title-h1-box h1{
      font-size: 32px;
    }
    .title-h1-box{
      background-repeat: no-repeat,no-repeat;
      background-position: left 15px top 25px,left 170px top 25px;
      background-size: 160px 15px,100px 15px;
    }
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199px) {
  .title-h1-box h1{
      font-size: 32px;
    }
    .title-h1-box{
      background-repeat: no-repeat,no-repeat;
      background-position: left 15px top 25px,left 170px top 25px;
      background-size: 160px 15px,100px 15px;
    }
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  
}
</style>